"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logTiming;

var _getTiming = _interopRequireDefault(require("./getTiming"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function logTiming(_ref) {
  var tuneInApiClient = _ref.tuneInApiClient;
  var metrics = (0, _getTiming.default)();

  if (metrics) {
    tuneInApiClient.logging.infoLog({
      message: 'timing',
      context: {
        metrics: metrics,
        pagePath: window.location.pathname
      }
    });
  }
}